import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Paper from '@mui/material/Paper';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { styled, useTheme } from '@mui/material';
import { FormContainer, useForm } from "react-hook-form-mui";
import { BoxContainer } from "../layouts/Theme";
import useWidgetStore from "../store/useWidgetStore";
import useDataStore from "../store/useDataStore";
import { useFlow } from "../context/FlowContext";
import { useI18N } from "../context/I18NContext";
import { useSettings } from "../context/SettingsContext";
import { moneyFormat } from "../helpers/general";
import { PaymentOptionMembershipBuy, PaymentOptionMembershipMandate, PaymentOptionProviderAlternate, PaymentOptionProviderExternal, PaymentOptionProviderRemote } from "./Payment/PaymentOptions";
import ConfigHolder from "../config/ConfigHolder";
import MandateForm from "../partials/checkout/MandateForm";
import CartComponent from '../partials/checkout/Cart';
import PollingPaymentStatus from "../partials/checkout/PollingPaymentStatus";
import ErrorAlert from "../partials/ErrorAlert";
import { usePrepareCart } from "../hooks/query/usePrepareCart";
import { useUpdateCart } from "../hooks/query/useUpdateCart";
import { useSetConsumer } from "../hooks/query/useSetConsumer";
import { useAbort } from '../hooks/query/useAbort';
export default function Mandate(props) {
    var _a, _b;
    const flow = useFlow();
    const { t, ts } = useI18N();
    const theme = useTheme();
    const [subscription, setSubscription] = useState();
    const [paymentMethod, setPaymentMethod] = useState();
    const [displayPaymentMethod, setDisplayPaymentMethod] = useState();
    const [showMandateForm, setShowMandateForm] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [paymentError, setPaymentError] = useState();
    const formContextUpdateCart = useForm({});
    const updateCartQuery = useUpdateCart(formContextUpdateCart);
    const formContextPrepareCart = useForm({});
    const prepareCartQuery = usePrepareCart(formContextPrepareCart);
    const consumerQuery = useSetConsumer();
    const abortQuery = useAbort();
    useEffect(() => {
        var _a;
        setShowMandateForm(((_a = flow.currentRoute) === null || _a === void 0 ? void 0 : _a.route) === 'mandate1');
    }, [flow]);
    const { consumer, setConsumer, cart, booking, setCart, enabled, setEnabled, paymentMethods, setPaymentMethods, selectedCapacity, selectedApptype, selectedResource, getDaoAppointments, getDaoProducts, fees, setFees, isPaying, setIsPaying, } = useWidgetStore();
    const { apptypes } = useDataStore();
    const { api_key, widget_id, payment, hasCheckout, widgetMode } = useSettings();
    const [cartFees, setCartFees] = useState();
    const submitUrl = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'updateCart', 'checkout');
    const [submitLabel, setSubmitLabel] = useState('Betaling starten');
    const [errors, setErrors] = useState();
    const formContext = useForm({});
    useEffect(() => {
        setEnabled(Object.assign(Object.assign({}, enabled), { apptype: true, resource: true, product: true }));
        if (!cart.order_id && apptypes) {
            prepareCartQuery.refetch();
        }
    }, []);
    useEffect(() => {
        if ((!cart.order_id || cart.order_id.startsWith('tmp_')) && apptypes) {
            prepareCartQuery.refetch();
        }
    }, [apptypes]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (prepareCartQuery.data) {
            if (prepareCartQuery.data.status.status === 'failed') {
                if (prepareCartQuery.data.status.userMessages) {
                    let _errors = [];
                    _errors.push(prepareCartQuery.data.status.message);
                    Object.values(prepareCartQuery.data.status.userMessages).map((error, i) => {
                        _errors.push(error);
                    });
                    setErrors(_errors);
                }
                else {
                    setErrors([prepareCartQuery.data.status.message]);
                }
            }
            else {
                if (prepareCartQuery.data.result.item && prepareCartQuery.data.result.item.paymentRequired && ((_a = prepareCartQuery.data.result.item.order) === null || _a === void 0 ? void 0 : _a.order_id)) {
                    setCart(Object.assign(Object.assign({}, cart), { order_id: (_b = prepareCartQuery.data.result.item.order) === null || _b === void 0 ? void 0 : _b.order_id }));
                    let methods = prepareCartQuery.data.result.item.paymentMethods, 
                    // 'none' and 'alternate' are not external providers: 'none' is paying at the
                    // counter and 'alternate' is a subscription or strippenkaart. Counting either
                    // as an external adds a "Losse afspraak maken" option the backend never
                    // offered, and hides the "Niet online afrekenen" one that it did.
                    externals = methods.filter((method) => method !== 'none' && method !== 'alternate');
                    if (externals.length > 0) {
                        methods.push("external");
                    }
                    if (consumer.subscriptions && consumer.subscriptions.length > 0) {
                        // if subscription has a subscriptionId, we own and can use it — the backend
                        // returns 'alternate' itself these days, so only add it if it is missing
                        if (!methods.includes("alternate")) {
                            methods.push("alternate");
                        }
                    }
                    setPaymentMethods(methods);
                    if (flow.onNext && cart.order_id) {
                        // these never change, and by setting them here we can render the next view instantly
                        flow.onNext();
                    }
                }
                else {
                    setCart(Object.assign(Object.assign({}, cart), { order_id: undefined }));
                    if (flow.onNext) {
                        if (((_c = flow.nextRoute) === null || _c === void 0 ? void 0 : _c.route) === 'thankYou') {
                            let thankYou = flow.views.find((view) => {
                                return view.route.route === 'thankYou';
                            });
                            if (thankYou && ((_d = thankYou.config) === null || _d === void 0 ? void 0 : _d.redirect)) {
                                if (widgetMode === 'standalone') {
                                    window.location.href = (_e = thankYou.config) === null || _e === void 0 ? void 0 : _e.redirect;
                                }
                                else {
                                    window.parent.postMessage({
                                        type: 'redirect',
                                        url: (_f = thankYou.config) === null || _f === void 0 ? void 0 : _f.redirect
                                    }, '*');
                                }
                            }
                        }
                        flow.onNext();
                    }
                }
            }
        }
    }, [prepareCartQuery.data]);
    useEffect(() => {
        if (cart.mandatables.length > 0) {
            setSubscription(cart.mandatables[0]);
        }
    }, [cart.mandatables]);
    useEffect(() => {
        if (apptypes && subscription && !isPaying) {
            let selectedSubscription = formContextUpdateCart.getValues("selectedSubscription");
            if (!selectedSubscription || selectedSubscription.id !== subscription.id) {
                formContextUpdateCart.setValue("selectedSubscription", subscription);
                // @ts-ignore
                formContextUpdateCart.setValue("paymentMethod", `membership_${subscription.id}`);
                formContextUpdateCart.setValue("paymentOption", "full");
                if (displayPaymentMethod === null || displayPaymentMethod === void 0 ? void 0 : displayPaymentMethod.endsWith('_mandate')) {
                    formContextUpdateCart.setValue("createMandate", true);
                }
                updateCartQuery.refetch();
            }
        }
    }, [subscription, apptypes, displayPaymentMethod]);
    useEffect(() => {
        // if(!updateCartQuery.isFetching) {
        formContextUpdateCart.setValue("createMandate", displayPaymentMethod === null || displayPaymentMethod === void 0 ? void 0 : displayPaymentMethod.endsWith('_mandate'));
        updateCartQuery.refetch();
        //  }
    }, [displayPaymentMethod]);
    useEffect(() => {
        var _a, _b;
        if (updateCartQuery.data) {
            let status = updateCartQuery.data.status, result = (_a = updateCartQuery.data.result) === null || _a === void 0 ? void 0 : _a.item;
            if (status.status !== "success" || !result) {
                abortQuery.refetch();
            }
            else {
                if ((_b = result === null || result === void 0 ? void 0 : result.order) === null || _b === void 0 ? void 0 : _b.order_id) {
                    if (cart.order_id !== result.order.order_id) {
                        let _paymentMethods = updateCartQuery.data.result.item.paymentMethods;
                        if (!_paymentMethods.includes("external"))
                            _paymentMethods.push("external");
                        if (!_paymentMethods.includes("alternate"))
                            _paymentMethods.push("alternate");
                        if (paymentMethods.sort().toString() == paymentMethods.sort().toString()) {
                            setPaymentMethods(_paymentMethods);
                        }
                        // @ts-ignore
                        setFees(result.fees);
                        setCart(Object.assign(Object.assign({}, cart), { lines: result.lines, giftCards: result.giftCards, 
                            // discounts: result.discounts, we keep track of the applied discounts locally
                            order_id: result.order.order_id, token: result.csrfToken }));
                    }
                }
            }
        }
    }, [updateCartQuery]);
    useEffect(() => {
        if (consumerQuery.data) {
            if (consumerQuery.data.result.item.mandate) {
                setConsumer(Object.assign(Object.assign({}, consumer), { mandate: consumerQuery.data.result.item.mandate }));
                setIsPaying(false);
                setShowMandateForm(true);
            }
            else {
                setTimeout(() => {
                    consumerQuery.refetch();
                }, 1000);
            }
        }
    }, [consumerQuery.data]);
    useEffect(() => {
        var _a, _b, _c;
        if (cart.currentPayment) {
            let failed = true;
            if (cart.currentPayment.status === "success" && ((_b = (_a = cart.currentPayment) === null || _a === void 0 ? void 0 : _a.transaction) === null || _b === void 0 ? void 0 : _b.final)) {
                failed = false;
                if (displayPaymentMethod === null || displayPaymentMethod === void 0 ? void 0 : displayPaymentMethod.endsWith('mandate')) {
                    // the initialfee was paid, get the mandate, but wait for a bit so the transaction if finalized and we actually have a mandate
                    setTimeout(() => {
                        consumerQuery.refetch();
                    }, 1000);
                }
                else {
                    if (flow.onNext) {
                        flow.onNext();
                    }
                }
            }
            else if (cart.currentPayment.status === "open") {
                failed = false;
            }
            else if (cart.currentPayment.status === "failed") {
                setPaymentError([t("Er is iets misgegaan bij het betalen. Probeer het later opnieuw.", "payment")]);
            }
            else if (cart.currentPayment.status === "cancelled") {
                setPaymentError([t("Je hebt de betaling geannuleerd", "payment")]);
            }
            else if (cart.currentPayment.status === "expired") {
                setPaymentError([t("De betaling is verlopen. Probeer het later opnieuw.", "payment")]);
            }
            else {
                setPaymentError([t("Er is iets misgegaan bij het betalen. Probeer het later opnieuw.", "payment")]);
            }
            if (failed) {
                setIsPaying(false);
                // Same as in Payment: the membership we tried to buy is a line in the cart, and
                // getDaoProducts turns every non-appointment line into a product on the next updateCart.
                // The backend reads that as another one to buy on top of the one it adds for the
                // appointment, so the cart doubles. That line is what has to go - the products stay, or a
                // retry after a failed payment would be for the appointment alone. Read the method the
                // update will be sent with, not the `paymentMethod` state, which is on 'ideal' by the
                // time the payment is started.
                let payingWith = formContextUpdateCart.getValues('paymentMethod');
                setCart(Object.assign(Object.assign({}, cart), { lines: (payingWith === null || payingWith === void 0 ? void 0 : payingWith.startsWith('subscription')) || (payingWith === null || payingWith === void 0 ? void 0 : payingWith.startsWith('membership'))
                        ? cart.lines.filter((line) => !["subscription", "membership"].includes(line.productType))
                        : cart.lines, currentPayment: undefined }));
                setDisplayPaymentMethod(undefined);
                let radio = document.querySelector(`input[name=paymentMethod][value=${displayPaymentMethod}]`);
                if (radio) {
                    //@ts-ignore
                    (_c = radio.parentNode) === null || _c === void 0 ? void 0 : _c.click();
                }
            }
        }
    }, [(_a = cart === null || cart === void 0 ? void 0 : cart.currentPayment) === null || _a === void 0 ? void 0 : _a.status]);
    useEffect(() => {
        var _a, _b;
        if (!displayPaymentMethod && subscription) {
            setDisplayPaymentMethod(subscription.buyable ? `membership_${subscription.id}` : `membership_${subscription.id}_mandate`);
        }
        if (displayPaymentMethod && subscription) {
            let value = displayPaymentMethod;
            if (displayPaymentMethod.endsWith('_mandate')) {
                // value = displayPaymentMethod
            }
            else {
                value = subscription.buyable ? `membership_${subscription.id}` : `membership_${subscription.id}_mandate`;
            }
            let radio = document.querySelector(`input[name=displayPaymentMethod][value=${value}]`);
            if (radio) {
                //@ts-ignore
                (_a = radio.parentNode) === null || _a === void 0 ? void 0 : _a.click();
                let radio2 = document.querySelector(`input[name=paymentMethod][value=ideal]`);
                // if there are external payment options available in the form ( which is always ideal as the only option )
                // select it
                if (radio2) {
                    //@ts-ignore
                    (_b = radio2.parentNode) === null || _b === void 0 ? void 0 : _b.click();
                }
            }
        }
    }, [paymentMethods, displayPaymentMethod, subscription]);
    const onChange = (event) => {
        let newPaymentMethod = event.currentTarget.value;
        if (newPaymentMethod.startsWith("membership") || newPaymentMethod.startsWith("subscription")) {
            setDisplayPaymentMethod(newPaymentMethod);
            setEnableSubmit(!newPaymentMethod.endsWith("mandate"));
        }
        else {
            setPaymentMethod(newPaymentMethod);
            setEnableSubmit(true);
        }
        setCartFees([]);
        if (newPaymentMethod) {
            if (fees[newPaymentMethod]) {
                let fee = fees[newPaymentMethod];
                if (fee.full && fee.full > 0) {
                    setCartFees([{
                            name: t('Transactiekosten'),
                            value: fee.full / 100
                        }]);
                }
            }
        }
    };
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        verticalAlign: 'top',
        textAlign: 'right',
        minWidth: '4em'
    }));
    const PaymentOption = ({ subscription, provider, variant }) => {
        if (provider) {
            if (provider.key === 'external') {
                return _jsx(PaymentOptionProviderExternal, { provider: provider, useDeposit: false, fees: fees });
            }
            else if (provider.key === 'alternate') {
                return _jsx(PaymentOptionProviderAlternate, { provider: provider, useDeposit: false, fees: fees });
            }
            else if ((subscription === null || subscription === void 0 ? void 0 : subscription.type) === 'membership' && (subscription === null || subscription === void 0 ? void 0 : subscription.buyable) && variant === "full") {
                return _jsx(PaymentOptionMembershipBuy, { subscription: subscription });
            }
            else if ((subscription === null || subscription === void 0 ? void 0 : subscription.type) === 'membership' && (subscription === null || subscription === void 0 ? void 0 : subscription.mandatable) && variant === "mandate") {
                return _jsx(PaymentOptionMembershipMandate, { subscription: subscription });
            }
            else {
                return _jsx(PaymentOptionProviderRemote, { provider: provider, useDeposit: false, fees: fees });
            }
        }
        return (_jsx(_Fragment, {}));
    };
    const onSubmit = (data, event) => {
        if (!(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.endsWith('_mandate'))) {
            // remove the mandatable, so the next flow step skips mandate1
            setCart(Object.assign(Object.assign({}, cart), { mandatables: [] }));
        }
        else {
            if (flow) {
                flow.onNext();
            }
        }
    };
    const onError = (errors) => { };
    const prepareSubmit = (event) => {
        // // this gets posted into a new tab
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        let _appointments = getDaoAppointments(), 
        // The membership line itself is left out - the backend creates that one, and posting it back
        // buys a second one - but the products are not: this request carries a subscriptionTypeId, so
        // the backend rebuilds the order from what is posted here, and leaving them out drops them
        // from the order that the mandate payment settles (see useUpdateCart).
        _products = getDaoProducts().filter((product) => !["subscription", "membership"].includes(product.type)), selectedSubscription = formContextUpdateCart.getValues('selectedSubscription');
        let data = {
            order_id: (_a = cart.order_id) !== null && _a !== void 0 ? _a : '',
            giftCards: cart.giftCards,
            discounts: cart.discounts,
            appointments: [{
                    appTypeId: selectedApptype, // booking?.appointments[0]?.components[0]?.appointmentTypes,
                    resourceId: selectedResource,
                    capacity: selectedCapacity,
                    components: _appointments,
                    date: (_b = _appointments[0].date) !== null && _b !== void 0 ? _b : _appointments[0].time,
                    time: _appointments[0].time,
                    fields: (_c = consumer.fields) !== null && _c !== void 0 ? _c : {},
                    remark: (_d = booking.remark) !== null && _d !== void 0 ? _d : ''
                }],
            products: _products,
            paymentMethod: "ideal",
            paymentOption: "full",
            final: true,
            widgetUrl: window.location.href,
            subscriptionTypeId: (_e = selectedSubscription === null || selectedSubscription === void 0 ? void 0 : selectedSubscription.id) !== null && _e !== void 0 ? _e : undefined
        };
        if (displayPaymentMethod === null || displayPaymentMethod === void 0 ? void 0 : displayPaymentMethod.endsWith('_mandate')) {
            data.createMandate = true;
        }
        const payload = document.getElementById('payload');
        if (payload) {
            payload.value = JSON.stringify(data);
        }
        const csrfToken = document.getElementById('csrfToken');
        if (csrfToken) {
            csrfToken.name = (_g = (_f = cart.token) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : "";
            csrfToken.value = (_j = (_h = cart.token) === null || _h === void 0 ? void 0 : _h.token) !== null && _j !== void 0 ? _j : "";
        }
        const secureToken = document.getElementById('secureToken');
        if (secureToken) {
            secureToken.value = (_k = cart.secureToken) !== null && _k !== void 0 ? _k : "";
        }
        setTimeout(() => {
            // this is a tiny bit of delay, because otherwise we would rerender instantly, causing the actual
            // POST to never proceed
            setIsPaying(true);
        }, 250);
    };
    return (_jsxs(BoxContainer, { children: [paymentError && (_jsx(ErrorAlert, { messages: paymentError, setter: setPaymentError })), cart.order_id && isPaying && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(PollingPaymentStatus, { method: 'ideal', paymentId: cart.order_id, transaction: {
                            redirectUrl: ""
                        } }), _jsx(Button, { type: "button", fullWidth: true, sx: {
                            my: 4
                        }, variant: "contained", onClick: flow.onPrevious, children: t("Betaling afbreken", "payment") })] })), !isPaying && (_jsxs(_Fragment, { children: [!showMandateForm && (_jsxs(_Fragment, { children: [_jsxs(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: [subscription && !updateCartQuery.isFetching
                                        && (!consumer.mandate || consumer.mandate.status !== "provisional") && (_jsx(CartComponent, { canDeposit: false, useDeposit: false, fees: cartFees, deposit: 0, locked: false, paymentMethod: (displayPaymentMethod === null || displayPaymentMethod === void 0 ? void 0 : displayPaymentMethod.endsWith("mandate")) ? "none" : "ideal", canRedeem: false })), _jsxs(Typography, { variant: "h6", sx: { color: theme.palette.text.primary }, children: [subscription === null || subscription === void 0 ? void 0 : subscription.title, " ", t('abonnement afsluiten')] }), (!consumer.mandate || consumer.mandate.status !== "provisional") && (_jsx(_Fragment, { children: cart.order_id && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: { marginLeft: 1, marginTop: 0, fontSize: '1rem' }, children: t('Hoe wil je betalen?') }), _jsx(RadioGroup, { name: "displayPaymentMethod", onChange: onChange, children: _jsx(TableContainer, { component: Paper, children: _jsx(Table, { sx: { width: '100%' }, size: "small", "aria-label": "a dense table", children: _jsx(TableBody, { children: subscription && (_jsxs(_Fragment, { children: [subscription.buyable && (_jsxs(TableRow, { sx: {
                                                                                backgroundColor: theme.palette.background.default,
                                                                                '&:last-child td, &:last-child th': { border: 0 }
                                                                            }, children: [_jsx(TableCell, { component: "th", scope: "row", colSpan: subscription.subscriptionId ? 2 : 1, children: _jsx(FormControlLabel, { value: `${subscription.type}_${subscription.id}`, control: _jsx(Radio, {}), label: _jsx(PaymentOptionMembershipBuy, { subscription: subscription, title: t("Direct betalen") }) }) }), !subscription.subscriptionId && (_jsx(StyledTableCell, { children: _jsx(Chip, { variant: 'filled', component: 'span', label: _jsx(_Fragment, { children: moneyFormat(subscription.sellPrice) }) }) }))] }, `${subscription.type}_${subscription.id}`)), _jsx(TableRow, { sx: {
                                                                                backgroundColor: theme.palette.background.default,
                                                                                '&:last-child td, &:last-child th': { border: 0 }
                                                                            }, children: _jsx(TableCell, { component: "th", scope: "row", colSpan: 3, children: _jsx(FormControlLabel, { value: `${subscription.type}_${subscription.id}_mandate`, control: _jsx(Radio, {}), label: _jsx(PaymentOptionMembershipMandate, { subscription: subscription, title: t("Gespreid betalen (incasso)") }) }) }) }, `${subscription.type}_${subscription.id}_mandate`)] })) }) }) }) }), displayPaymentMethod && !displayPaymentMethod.endsWith("mandate") && !updateCartQuery.isFetching && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(RadioGroup, { name: "paymentMethod", onChange: onChange, children: _jsx(TableContainer, { component: Paper, children: _jsx(Table, { sx: { width: '100%' }, size: "small", "aria-label": "a dense table", children: _jsx(TableBody, { children: payment.providers.map((provider) => {
                                                                            // Closing a subscription always costs something — the price, or the
                                                                            // inschrijfgeld when it is paid by mandate — so paying nothing online is
                                                                            // never an option here. It shows up because paymentMethods still holds the
                                                                            // list the payment view was working from.
                                                                            if (provider.key === 'none') {
                                                                                return (_jsx(Fragment, {}, provider.key));
                                                                            }
                                                                            if (!paymentMethods.includes(provider.key) || provider.key === 'directdebit') {
                                                                                return (_jsx(Fragment, {}, provider.key));
                                                                            }
                                                                            return (_jsxs(TableRow, { sx: {
                                                                                    backgroundColor: theme.palette.background.default,
                                                                                    '&:last-child td, &:last-child th': { border: 0 }
                                                                                }, children: [_jsx(TableCell, { component: "th", scope: "row", children: _jsx(FormControlLabel, { value: provider.key, control: _jsx(Radio, {}), label: _jsx(PaymentOption, { provider: provider }) }) }), _jsx(StyledTableCell, { children: provider.icon && (_jsx("img", { src: provider.icon, style: {
                                                                                                height: '3em',
                                                                                                aspectRatio: '4 / 3',
                                                                                                boxSizing: 'border-box'
                                                                                            } })) })] }, provider.key));
                                                                        }) }) }) }) })] })), displayPaymentMethod && displayPaymentMethod.endsWith("mandate") && !consumer.mandate && (_jsxs(_Fragment, { children: [_jsx(Divider, { sx: { marginTop: 3 } }), _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Het afsluiten van het abonnement met een machtiging gebeurt in 2 stappen.') }), _jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary }, children: t('Stap 1') }), (subscription === null || subscription === void 0 ? void 0 : subscription.initialFee) && (subscription === null || subscription === void 0 ? void 0 : subscription.initialFee) > 0 && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: ts('Je betaalt het inschrijfgeld van %fee% per iDeal.', { fee: moneyFormat(subscription === null || subscription === void 0 ? void 0 : subscription.initialFee) }) }), _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Deze betaling dient ter verificatie van je rekening. De betaling dient te gebeuren vanaf dezelfde rekening, waarvoor ook de machtiging afgegeven wordt.') })] })), parseInt(((_b = subscription === null || subscription === void 0 ? void 0 : subscription.initialFee) !== null && _b !== void 0 ? _b : "0").toString()) === 0 && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Je betaalt eenmalig 1 cent per iDeal om je rekeningte verifieren.') }), _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('De betaling dient te gebeuren vanaf dezelfde rekening, waarvoor ook de machtiging afgegeven wordt.') })] })), _jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Stap 2') }), _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Je geeft een machtiging af voor het maandelijkse abonnementsgeld') }), _jsx(_Fragment, { children: !updateCartQuery.isFetching && (_jsx(RadioGroup, { name: "paymentMethod", onChange: onChange, children: _jsx(TableContainer, { component: Paper, children: _jsx(Table, { sx: { width: '100%' }, size: "small", "aria-label": "a dense table", children: _jsx(TableBody, { children: payment.providers.map((provider) => {
                                                                                if (!paymentMethods.includes(provider.key) || provider.key !== 'ideal') {
                                                                                    return (_jsx(Fragment, {}, provider.key));
                                                                                }
                                                                                return (_jsxs(TableRow, { sx: {
                                                                                        backgroundColor: theme.palette.background.default,
                                                                                        '&:last-child td, &:last-child th': { border: 0 }
                                                                                    }, children: [_jsx(TableCell, { component: "th", scope: "row", children: _jsx(FormControlLabel, { value: provider.key, control: _jsx(Radio, {}), label: _jsx(PaymentOption, { provider: provider }) }) }), _jsx(StyledTableCell, { children: provider.icon && (_jsx("img", { src: provider.icon, style: {
                                                                                                    height: '3em',
                                                                                                    aspectRatio: '4 / 3',
                                                                                                    boxSizing: 'border-box'
                                                                                                } })) })] }, provider.key));
                                                                            }) }) }) }) })) })] }))] })) }))] }), displayPaymentMethod && displayPaymentMethod.endsWith("mandate") && consumer.mandate && subscription && (_jsx(_Fragment, { children: _jsx(MandateForm, { subscription: subscription }) }))] })), !isPaying && (!displayPaymentMethod || !displayPaymentMethod.endsWith("mandate") || (displayPaymentMethod.endsWith("mandate") && !consumer.mandate)) && (_jsxs("form", { action: submitUrl.href, target: '_blank', method: "POST", onSubmit: prepareSubmit, children: [_jsx("input", { type: "hidden", id: "payload", name: "payload" }), _jsx("input", { type: "hidden", id: "csrfToken", name: "token" }), _jsx("input", { type: "hidden", id: "secureToken", name: "secureToken" }), _jsx(Box, { sx: {}, children: _jsx(Button, { type: "submit", fullWidth: true, sx: {
                                        my: 4
                                    }, variant: "contained", disabled: !enableSubmit || updateCartQuery.isFetching, children: t(submitLabel, "payment") }) })] })), showMandateForm && subscription && (_jsx(MandateForm, { subscription: subscription }))] }))] }));
}
